<!--
  -  Copyright (c) Qwoach LLC 2021. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 27/2/2021
  -->

<template>
	<div class="step-title-root">
		<slot></slot>
	</div>
</template>

<script>
import BaseComponent from "@/core/components/BaseComponent.vue";

export default {
	name: "StepTitle",
	extends: BaseComponent,
}
</script>

<style lang="scss">
@import "@/assets/scss/style_v2/style_v2.scss";
.step-title-root{
	font-weight: $weight-bold;
	font-size: px-to-rem(24);
}
</style>
